<script>
import FormGroup from "@/Components/FormGroup.vue";
import InputSwitch from "primevue/inputswitch";

export default {
  name: "InputSwitchFormGroup",
  inheritAttrs: false,
  components: {FormGroup, InputSwitch},
  props: {
    name: String,
    label: String,
    helpText: String,
    errorText: String,
    disabled: Boolean,
  },
}
</script>

<template>
  <label
      class="hover:bg-slate-50 cursor-pointer transition-colors duration-200 p-4 rounded-md flex flex-col items-start justify-between ring-1 ring-surface-300"
      :class="{'bg-slate-50 pointer-events-none opacity-50': disabled}"
  >
    <FormGroup
        class="mb-2"
        :label="label"
        :help-text="helpText"
        :error-text="errorText"
    />
    <InputSwitch
        v-bind="$attrs"
        :disabled="disabled"
    />
  </label>
</template>

<style scoped>

</style>